import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {
    amountDataTableTemplate,
    numberWithCommaDataTableTemplate,
    priceDataTableTemplate,
    rateMultipliedByOneHundredDataTableTemplate
} from "../../../utils/formatters/Numbers";

const NewLoan = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Tablero de Control \ Préstamo Nuevo"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid item>
                            <Button
                                label="Regresar"
                                style={{'float': 'right'}}
                                className="p-button-secondary"
                                onClick={props.handleReturnButton}/>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid item xs={12}>
                        <TitlePage title="Préstamo"/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.loan}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column
                                field="emisora"
                                header="Emisora"
                                style={{textAlign: 'left'}}
                                sortable={true}/>
                            <Column
                                field="cantidadTitulos"
                                header="Títulos"
                                style={{textAlign: 'right'}}
                                body={numberWithCommaDataTableTemplate}
                                sortable={true}/>
                            <Column
                                field="precio"
                                header="Precio"
                                style={{textAlign: 'right'}}
                                body={priceDataTableTemplate}
                                sortable={true}/>
                        </DataTable>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        < Grid item xs={12}>
                            <TitlePage title="Detalles"/>
                        </Grid>
                        <Grid item xs={12}>
                            <DataTable
                                value={props.newLoan}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                <Column
                                    field="plazo"
                                    header="Plazo"
                                    style={{textAlign: 'right'}}
                                    body={numberWithCommaDataTableTemplate}
                                    sortable={true}/>
                                <Column
                                    field="tasa"
                                    header="Tasa"
                                    style={{textAlign: 'right'}}
                                    body={rateMultipliedByOneHundredDataTableTemplate}
                                    sortable={true}/>
                                <Column
                                    field="sobreTasa"
                                    header="Sobretasa"
                                    style={{textAlign: 'right'}}
                                    body={rateMultipliedByOneHundredDataTableTemplate}
                                />
                                <Column
                                    field="premio"
                                    header="Premio"
                                    style={{textAlign: 'right'}}
                                    body={amountDataTableTemplate}
                                    sortable={true}/>
                            </DataTable>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid item xs={12}>
                        <TitlePage title="Garantías"/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.guarantee}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column
                                field="emisora"
                                header="Emisora"
                                style={{textAlign: 'left'}}
                                sortable={true}/>
                            <Column
                                field="titulos"
                                header="Títulos"
                                style={{textAlign: 'right'}}
                                body={numberWithCommaDataTableTemplate}
                                sortable={true}/>
                            <Column
                                field="precioMercado"
                                header="Precio Mercado"
                                style={{textAlign: 'right'}}
                                body={priceDataTableTemplate}
                                sortable={true}c/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default NewLoan;